module.exports = __webpack_public_path__ + "static/profile-image-6-b819cf292e28b820481e6a76f5062ba7.jpeg";